import React from 'react'

import { StyledMain } from './styles'

export enum SiderRightVariants {
  BANNER = 'banner',
  GLOBAL_HEADER = 'globalHeader',
  BANNER_AND_HEADER = 'bannerAndHeader',
}

export interface CustomHeaderProps {
  headerChildren?: React.ReactNode
  mainChildren?: React.ReactNode
  footerChildren?: React.ReactNode
  variant?: string
}

const SiderRight = ({
  headerChildren,
  mainChildren,
  footerChildren,
  variant = SiderRightVariants.BANNER,
}: CustomHeaderProps) => {
  return (
    <StyledMain id="nova-shared-Sider-Right-root" className={`${variant}`}>
      <div className="header">{headerChildren}</div>
      <div className={['main', footerChildren && 'with-footer'].join(' ')}>{mainChildren}</div>
      {footerChildren && <div className="footer">{footerChildren}</div>}
    </StyledMain>
  )
}

export default SiderRight
